import React, { KeyboardEventHandler, useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import { MultiValue } from 'react-select'

interface TagOption {
  readonly label: string
  readonly value: string
}

interface TagsInputProps {
  value: string[]
  onChange: (next: string[]) => void
  placeholder?: string
  isDisabled?: boolean
}

const noDropdownComponents = {
  DropdownIndicator: null,
  Menu: () => null,
}

const toOption = (value: string): TagOption => ({
  label: value,
  value,
})

function TagsInput({
  value,
  onChange,
  placeholder,
  isDisabled,
}: TagsInputProps) {
  const [inputValue, setInputValue] = useState('')

  const options = value.map(toOption)

  const commitInput = () => {
    const trimmed = inputValue.trim()
    if (trimmed === '') {
      return
    }
    if (!value.includes(trimmed)) {
      onChange([...value, trimmed])
    }
    setInputValue('')
  }

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (inputValue.trim() === '') {
      return
    }
    if (event.key === 'Enter' || event.key === 'Tab' || event.key === ',') {
      commitInput()
      event.preventDefault()
    }
  }

  return (
    <CreatableSelect
      className="select"
      classNamePrefix="select"
      components={noDropdownComponents}
      inputValue={inputValue}
      isClearable={false}
      isMulti
      isDisabled={isDisabled}
      menuIsOpen={false}
      placeholder={placeholder}
      value={options}
      onChange={(newValue: MultiValue<TagOption>) => {
        onChange(newValue.map((option) => option.value))
      }}
      onInputChange={(newValue) => setInputValue(newValue)}
      onKeyDown={handleKeyDown}
      onBlur={commitInput}
    />
  )
}

TagsInput.defaultProps = {
  placeholder: '',
  isDisabled: false,
}

export default TagsInput
